import React, { Component } from 'react';
import { Row, Col, Card, Badge } from 'react-bootstrap';
import {
  FaMailBulk, FaUser, FaPhone, FaCalendar,
  FaBriefcase, FaMapPin, FaHeart
} from 'react-icons/fa';

class UserView extends Component {
  render() {
    const { userProfile, userData, getProvinceName } = this.props;

    return (
      <div className="user-profile-view">
        <Row>
          <Col md={6} className="mb-4">
            <div className="profile-field">
              <div className="field-label">
                <FaMailBulk size={18} className="me-2 text-primary" />
                Email
              </div>
              <div className="field-value">{userData?.user_email || 'Not set'}</div>
            </div>
          </Col>
          <Col md={6} className="mb-4">
            <div className="profile-field">
              <div className="field-label">
                <FaUser size={18} className="me-2 text-primary" />
                Full Name
              </div>
              <div className="field-value">{userProfile.name || 'Not set'}</div>
            </div>
          </Col>
        </Row>

        <Row>
          <Col md={6} className="mb-4">
            <div className="profile-field">
              <div className="field-label">
                <FaPhone size={18} className="me-2 text-primary" />
                Phone
              </div>
              <div className="field-value">{userProfile.phone || 'Not set'}</div>
            </div>
          </Col>
          <Col md={6} className="mb-4">
            <div className="profile-field">
              <div className="field-label">
                <FaCalendar size={18} className="me-2 text-primary" />
                Date of Birth
              </div>
              <div className="field-value">
                {userProfile.dob ? userProfile.dob.toLocaleDateString('id-ID') : 'Not set'}
              </div>
            </div>
          </Col>
        </Row>

        <Row>
          <Col md={6} className="mb-4">
            <div className="profile-field">
              <div className="field-label">
                <FaBriefcase size={18} className="me-2 text-primary" />
                Profession
              </div>
              <div className="field-value">{userProfile.profession || 'Not set'}</div>
            </div>
          </Col>
          <Col md={6} className="mb-4">
            <div className="profile-field">
              <div className="field-label">
                <FaUser size={18} className="me-2 text-primary" />
                Gender
              </div>
              <div className="field-value">
                {userProfile.sex === "0" ? 'Female' : userProfile.sex === "1" ? 'Male' : 'Not set'}
              </div>
            </div>
          </Col>
        </Row>

        <Row>
          <Col md={6} className="mb-4">
            <div className="profile-field">
              <div className="field-label">
                <FaMapPin size={18} className="me-2 text-primary" />
                Location
              </div>
              <div className="field-value">{getProvinceName(userProfile.location)}</div>
            </div>
          </Col>
          <Col md={6} className="mb-4">
            <div className="profile-field">
              <div className="field-label">
                <FaHeart size={18} className="me-2 text-primary" />
                Marital Status
              </div>
              <div className="field-value">
                {userProfile.marriage === "0" ? 'Single' : 
                 userProfile.marriage === "1" ? 'Married' : 
                 userProfile.marriage === "2" ? 'Widow' : 'Not set'}
              </div>
            </div>
          </Col>
        </Row>

        <Row>
          <Col md={6} className="mb-4">
            <div className="profile-field">
              <div className="field-label">Smoking Habit</div>
              <div className="field-value">
                <Badge bg={userProfile.smoking === 1 ? 'danger' : 'success'}>
                  {userProfile.smoking === 1 ? 'Yes' : 'No'}
                </Badge>
              </div>
            </div>
          </Col>
        </Row>

        <div className="profile-field">
          <div className="field-label">Bio</div>
          <div className="field-value bio-text">
            {userProfile.bio || 'No bio provided'}
          </div>
        </div>
      </div>
    );
  }
}

export default UserView;
